/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import cssClasses from "./TermsAndCondition.module.css";
import Close from "../../Components/Icons/Close";
import Button from "../../Subcomponents/Button";
import TermsAndConditionJson from "./TermsAndConditons.json";

const useStyles = makeStyles((theme) => ({
	wrapperIcons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		justifyContent: "space-around",
		marginBottom: "2rem",
		position: "relative",
	},

	closeIcon: {
		cursor: "pointer",
		position: "absolute",
		right: "0rem",
	},
	title: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "3rem",
		lineHeight: "3.8rem",
		color: "#101828",
		marginBottom: "1.8rem",
	},
	subTitle: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.6rem",
		lineHeight: "2.4rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	wrapperButtons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		columnGap: "1.2rem",
	},
}));
export default function TermsAndCondition({ open, handleClose }) {
	const classes = useStyles();

	function close() {
		handleClose();
	}
	return (
		<Modal
			open={open}
			onClose={(_, reason) => {
				if (reason !== "backdropClick") {
					handleClose();
				}
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			sx={[
				{
					".MuiBackdrop-root": {
						background: "rgba(52, 64, 84, 0.7)",
					},
				},
			]}
			disableAutoFocus={true}
			button
		>
			<Box className={cssClasses.modalWrapper}>
				<div className={classes.wrapperIcons}>
					{/* {icon} */}
					<span className={classes.closeIcon} onClick={handleClose}>
						<Close width={"1.2rem"} height={"1.2rem"} />
					</span>
				</div>
				<div className={classes.title}>TERMS OF SERVICE AGREEMENT</div>
				<div className={cssClasses.wrapperContent}>
					{TermsAndConditionJson.agreementArray.map((each, index) => {
						return (
							<div className={cssClasses.wrapperTermsAndConditionsIndex}>
								<div className={cssClasses.termsAndConditionsIndex}>{each.title}</div>
								{each.type && <span className={cssClasses.welcomeMessage}>{each.type}</span>}
								{each.message && <span className={cssClasses.welcomeMessage} dangerouslySetInnerHTML={{ __html: each.message }} />}
								{each.note && <span className={cssClasses.welcomeMessage}>{each.note}</span>}
							</div>
						);
					})}
				</div>
			</Box>
		</Modal>
	);
}
